<template>
  <div class="nebInfocon"
    :class="orientation"
  >
    <div class="nebInfocon-iconWrapper">
      <neb-icon :name="icon"
        :height="iconHeight"
        :width="iconWidth"
        :options="options"
      ></neb-icon>
    </div>

    <div class="nebInfocon-infoWrapper">
      <p class="nebInfocon-text"
        :style="{
          fontSize
        }"
      >
        {{ info }}
      </p>
    </div>
  </div>
</template>

<script>
import NebIcon from '../../Icon'

export default {
  name: 'NebInfocon',

  components: {
    NebIcon
  },

  props: {
    icon: {
      type: String,
      required: true
    },
    info: {
      type: String,
      default: ''
    },
    orientation: {
      type: String,
      default: 'horizontal'
    },
    iconHeight: {
      type: String,
      default: '16px'
    },
    iconWidth: {
      type: String,
      default: '16px'
    },
    fontSize: {
      type: String,
      default: '14px'
    },
    /**
     * Options passed to the icon.
     */
    options: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss">
@import '../../style.scss';

.nebInfocon {
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 1px;

  &-infoWrapper {
    margin-left: 4px;
  }

  &-text {
    margin: 0;
    font-family: $defaultFont;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: $slate-grey;
  }

  &.vertical {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
